import React from 'react'
import { CobuCard, CobuStack, CobuText, CobuView } from '@cobu/ui'
import FavoriteIcon from '@mui/icons-material/Favorite'
import MapIcon from '@mui/icons-material/Map'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import type { Place } from '@cobu/types'
import { CategoryBadge } from './CategoryBadge'
import { CATEGORY_META } from './categoryMeta'
import { formatPlaceAddressLine } from './placeFormat'

interface PlaceCardProps {
  place: Place
  onPress: (place: Place) => void
}

export function PlaceCard({ place, onPress }: PlaceCardProps) {
  const addressLine = formatPlaceAddressLine(place)

  const CategoryIcon = CATEGORY_META[place.category].icon

  return (
    <CobuCard mx="$4" my="$2" p="$3">
      <CobuView onPress={() => onPress(place)}>
        <CobuStack layout="horizontal" gap="$3">
          <CobuStack w={64} h={64} br="$3" ai="center" jc="center" bg="$background" flexShrink={0}>
            <CategoryIcon style={{ fontSize: 22, opacity: 0.4 }} />
          </CobuStack>

          <CobuStack f={1} gap="$1" jc="center">
            <CobuStack layout="horizontal" ai="flex-start" jc="space-between" gap="$2">
              <CobuText variant="body" fontWeight="600" fontSize="$4" f={1} numberOfLines={2}>
                {place.name}
              </CobuText>
              <CobuStack flexShrink={0}>
                <CategoryBadge category={place.category} />
              </CobuStack>
            </CobuStack>

            <CobuText variant="caption" color="$colorSecondary">
              {addressLine}
            </CobuText>

            <CobuStack layout="horizontal" ai="center" gap="$3" mt="$1">
              <CobuStack layout="horizontal" ai="center" gap="$1">
                <FavoriteIcon style={{ fontSize: 14, color: place.myLike ? '#EF4A4A' : undefined }} />
                <CobuText variant="caption" color="$colorSecondary">{place.likeCount}</CobuText>
              </CobuStack>
              <CobuStack layout="horizontal" ai="center" gap="$1">
                <MapIcon style={{ fontSize: 14 }} />
                <CobuText variant="caption" color="$colorSecondary">{place.beenCount}</CobuText>
              </CobuStack>
              <CobuStack layout="horizontal" ai="center" gap="$1">
                <ChatBubbleOutlineIcon style={{ fontSize: 14 }} />
                <CobuText variant="caption" color="$colorSecondary">{place.commentCount}</CobuText>
              </CobuStack>
            </CobuStack>
          </CobuStack>
        </CobuStack>
      </CobuView>
    </CobuCard>
  )
}
